<template>
  <div class="calender-page">
    <media-library-menu
      :dragMove="onMoveCallback"
      v-model="mediaList"
      @select="select"
      @savedSelected="savedSelected"
    ></media-library-menu>
    <div class="right-container">
      <plan-header
        :switchPublisher="switchPublisher"
        ref="planHeader"
      ></plan-header>
      <template
        v-if="
          $route.query.type !== 'drag' &&
          $route.query.type !== 'repost' &&
          $route.query.type !== 'bulk'
        "
      >
        <div class="calender-top-info">
          <process-loading
            v-show="listType === 0"
            ref="calenderProcess"
          ></process-loading>
          <div v-show="listType === 0" class="date-container">
            <div class="icon left" @click="updateMonth(-1)"></div>
            <div class="current" @click="today">Today</div>
            <div class="icon right" @click="updateMonth(1)"></div>
            <div class="date">{{ dateRangeText }}</div>
          </div>
          <div v-show="listType === 1" class="date-container">
            <hi-tab
              v-model="listTypeIndex"
              :tabList="tabList"
              height="50px"
              class="list-type-tab"
            ></hi-tab>
          </div>
          <div
            class="only-text-container"
            v-if="showOnlyText"
            @click="onlyTextClick"
          >
            <div class="icon"></div>
            <div class="text">What’s on your mind?</div>
          </div>
          <div
            class="info-right-container"
            :class="{ 'list-type': listType === 1 }"
          >
            <div class="time-zone-container week-time-zone">
              <div class="time-zone-text">Time Zone</div>
              <div class="select-container">
                <select v-model="zone">
                  <option v-for="item in timezones" :key="item" :value="item">
                    {{ item }}
                  </option>
                </select>
                <div class="select-down-icon"></div>
              </div>
            </div>
            <hi-tabs
              v-show="listType === 0"
              v-model="calenderType"
              height="30px"
              class="week-month"
            >
              <hi-tab-panel title="Week"></hi-tab-panel>
              <hi-tab-panel title="Month"></hi-tab-panel>
            </hi-tabs>
            <hi-tabs v-model="listType" height="30px" class="list-type">
              <hi-tab-panel
                :icon="{
                  active: '../../../images/schedule_posts/tab_list_1s@3x.png',
                  void: '../../../images/schedule_posts/tab_list_1n@3x.png',
                }"
              ></hi-tab-panel>
              <hi-tab-panel
                :icon="{
                  active: '../../../images/schedule_posts/tab_list_2s@3x.png',
                  void: '../../../images/schedule_posts/tab_list_2n@3x.png',
                }"
              ></hi-tab-panel>
            </hi-tabs>
          </div>
        </div>
        <div
          class="top-month-day-container"
          v-show="listType === 0 && calenderType === 1"
        >
          <div class="week-container" style="padding-left: 30px">
            <div v-for="i in monthWeekStr" class="week-item">{{ i }}</div>
          </div>
        </div>
        <!--周历-->
        <div
          class="top-week-day-container"
          v-show="listType === 0 && calenderType === 0"
        >
          <div class="week-container">
            <div v-for="day in weekDayStr" class="week-item">{{ day.str }}</div>
          </div>
        </div>
        <div
          class="calender-container"
          id="calenderContainer"
          v-show="listType === 0"
        >
          <div class="drag-mask" id="scheduleMask" style="display: none"></div>
          <div
            id="weekScroll"
            class="calender-scroll-container"
            v-show="calenderType === 0"
          >
            <div class="calender-component">
              <div class="calender-week-container">
                <div class="calender-week-time-container">
                  <div class="week-time-item" v-for="time in weekTimes">
                    <div class="time-text">{{ time }}</div>
                  </div>
                </div>
                <div
                  class="day-column"
                  :class="{ now: day.now }"
                  v-for="day in weekDayStr"
                >
                  <div
                    class="day-row"
                    :class="[weekType(day.date, time), weekNow(day.date, time)]"
                    v-for="time in weekTimes"
                  >
                    <div
                      v-for="(item, itemIndex) in postTimeInfo(day.date, time)"
                      @click="showPostDetail(item)"
                      :key="item.id"
                      :class="[
                        {
                          story: item.mediaType === 3,
                          post: item.mediaType === 1,
                        },
                        item.state,
                      ]"
                      class="post-item common-post-item"
                      v-if="itemIndex < 3"
                    >
                      <div class="time-text">{{ item.postTimeStr }}</div>
                      <div class="post-image-container">
                        <div
                          v-lazy:background-image="item.coverUrl"
                          :key="item.coverUrl"
                          class="post-image"
                        >
                          <div v-show="item.isVideo" class="video-icon"></div>
                          <div
                            class="link-icon"
                            v-if="item.mediaType === 90 && item.storyUrl"
                          ></div>
                          <div
                            class="mul-icon"
                            v-show="item.mediaList.length > 1"
                          ></div>
                        </div>
                      </div>
                      <div
                        v-if="
                          currentPublisher.socialNetwork === 1 &&
                          (item.mediaType === 3 ||
                            item.mediaType === 8 ||
                            item.mediaType === 22 ||
                            !currentPublisher.isBusiness)
                        "
                        class="post-state-icon black"
                        @click.stop="iconClick(item)"
                      ></div>
                      <div
                        v-else
                        class="post-state-icon"
                        @click.stop="iconClick(item)"
                      ></div>
                    </div>
                    <div
                      class="post-item common-post-item more"
                      v-if="postTimeInfo(day.date, time).length > 3"
                    >
                      <post-more
                        @itemClick="showPostDetail"
                        :model="{
                          date: day.date,
                          items: postTimeInfo(day.date, time),
                        }"
                      ></post-more>
                    </div>
                    <div class="line"></div>
                    <div class="now-line"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--月历-->
          <div
            id="calenderScroll"
            class="calender-scroll-container"
            style="padding-left: 30px"
            v-show="calenderType === 1"
          >
            <div class="calender-component">
              <div class="calender-date-container">
                <div
                  v-for="(d, dayIndex) in days"
                  class="calender-date-item-container"
                  :class="{ now: d.now }"
                >
                  <div class="date-item">
                    <div class="day-container">{{ d.date }}</div>
                    <div class="calender-items-component">
                      <div
                        class="post-item common-post-item"
                        v-if="itemIndex < 3"
                        v-for="(item, itemIndex) in postDayInfo(dayIndex).items"
                        @click="showPostDetail(item)"
                        :class="[{ story: item.mediaType === 3 }, item.state]"
                      >
                        <div class="post-image-container">
                          <div
                            v-lazy:background-image="item.coverUrl"
                            :key="item.coverUrl"
                            class="post-image"
                          >
                            <div v-show="item.isVideo" class="video-icon"></div>
                            <div
                              class="mul-icon"
                              v-show="item.mediaList.length > 1"
                            ></div>
                            <div
                              class="link-icon"
                              v-if="item.mediaType === 90 && item.storyUrl"
                            ></div>
                            <div
                              v-if="
                                currentPublisher.socialNetwork === 1 &&
                                (item.mediaType === 3 ||
                                  item.mediaType === 8 ||
                                  item.mediaType === 22 ||
                                  !currentPublisher.isBusiness)
                              "
                              class="post-state-icon black"
                              @click.stop="iconClick(item)"
                            ></div>
                            <div
                              v-else
                              @click.stop="iconClick(item)"
                              class="post-state-icon"
                            ></div>
                          </div>
                        </div>
                        <div class="time-container">
                          <div class="start-time">{{ item.postTimeStr }}</div>
                          <div class="end-time" v-if="item.deleteTimeStr">
                            ➞
                          </div>
                          <div class="end-time">{{ item.deleteTimeStr }}</div>
                        </div>
                      </div>
                      <post-more
                        @itemClick="showPostDetail"
                        :model="postDayInfo(dayIndex)"
                      ></post-more>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--列表-->
        <group-list
          ref="scheduleList"
          @itemClick="showPostDetail"
          type="schedule"
          v-show="listType === 1 && listTypeIndex === 0"
          :timezone="zone"
        ></group-list>
        <group-list
          ref="postedList"
          @itemClick="showPostDetail"
          type="posted"
          v-show="listType === 1 && listTypeIndex === 1"
          :timezone="zone"
        ></group-list>
      </template>
      <drag-page v-show="$route.query.type === 'drag'"></drag-page>
      <bulk-page
        ref="bulkPage"
        v-show="$route.query.type === 'bulk'"
      ></bulk-page>
      <search-repost-page
        v-if="$route.query.type === 'repost'"
        ref="repostPage"
      ></search-repost-page>
    </div>
    <calender-preview-dialog ref="previewDialog"></calender-preview-dialog>
    <schedule-post-detail ref="postDetail"></schedule-post-detail>
    <repost-detail
      @close="repostDetailDialog = false"
      v-show="repostDetailDialog"
      redf="repostDetail"
    ></repost-detail>
  </div>
</template>
<style lang="less" scoped>
@import "../../assets/style/theme.less";

@week-container-height: 70px;
@post-item-height: @week-container-height - 6px;
@calender-border-color: #ebedf8;
.calender-page {
  display: flex;

  .calender-week-container {
    .post-item.common-post-item {
      &.post-fail .post-state-icon {
        background-image: url("../../../public/images/schedule_posts/list/Reminder_Missed@3x.png") !important;
      }

      &.post-not-auto .post-state-icon {
        background-image: url("../../../public/images/schedule_posts/list/Reminder-red@3x.png") !important;
      }
      &.post-not-auto .post-state-icon.black {
        background-image: url("../../../public/images/schedule_posts/list/Reminder@3x.png") !important;
      }
    }
  }

  .time-zone-container {
    display: flex;
    align-items: center;

    .select-container {
      -webkit-appearance: none;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 30px;
      outline: 0;
      padding: 0 8px;
      margin-right: 25px;
      position: relative;

      select {
        border: 0;
        background: transparent;
        width: 150px;
        height: 100%;
        cursor: pointer;
        -webkit-appearance: none;
        font-size: 13px;
      }

      .select-down-icon {
        width: 13px;
        height: 13px;
        background-position: center;
        background-size: contain;
        background-image: url("../../../public/images/common/down_icon@3x.png");
        background-repeat: no-repeat;
        position: absolute;
        right: 10px;
        top: 8px;
      }
    }

    .time-zone-text {
      margin-right: 20px;
    }
  }

  .right-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100vh;
    min-width: 1210px;
    width: 1210px;
    .calender-top-info {
      display: flex;
      align-items: center;
      padding: 0 40px;
      height: 50px;
      border-bottom: 1px solid @calender-border-color;
      position: relative;
      .only-text-container {
        width: 180px;
        border-radius: 4px;
        background: rgb(245, 245, 245);
        padding: 5px 10px;
        color: rgb(210, 210, 210);
        border: 1px solid #dcdfe6;
        display: flex;
        cursor: pointer;
        align-items: center;
        font-size: 13px;
        .icon {
          width: 14px;
          height: 14px;
          background-image: url("../../../public/images/schedule_posts/icon@3x.png");
          background-size: contain;
          margin-right: 8px;
        }
        &:hover {
          opacity: 0.7;
        }
      }
      .date-container {
        width: 300px;
        font-size: 15px;
        display: flex;
        margin-right: 10px;
        align-items: center;
        font-weight: 500;

        .current {
          margin: 0 14px;
          color: @color-primary;
          cursor: pointer;

          &:hover {
            opacity: 0.3;
          }
        }

        .icon {
          width: 8px;
          height: 14px;
          background-size: 8px 14px;
          cursor: pointer;

          &.left {
            background-image: url("../../../public/images/schedule_posts/Date_Left@3x.png");
          }

          &.right {
            background-image: url("../../../public/images/schedule_posts/Date_Right@3x.png");
          }

          &:hover {
            opacity: 0.3;
          }
        }

        .date {
          margin-left: 9px;
        }

        .list-type-tab {
          width: 167px;
          height: 50px;
        }
      }

      .info-right-container {
        display: flex;
        flex: 1;
        align-items: center;
        font-size: 14px;
        /*width: 550px;*/
        justify-content: flex-end;

        .list-type {
          .calender-type {
            flex: none;
            margin-left: 20px;
          }
        }

        .week-month {
          width: 200px;
          margin-right: 25px;
          /*margin-left: 25px;*/
        }

        .list-type {
          width: 70px;
        }
      }
    }
  }

  .top-month-day-container {
    padding-top: 32px;
    margin-bottom: 5px;

    .week-container {
      width: 100%;
      border-bottom: 1px solid @calender-border-color;
      padding-bottom: 5px;

      .week-item {
        display: inline-block;
        width: 14.28%;
        height: 16px;
        line-height: 16px;
        font-size: 14px;
        padding-left: 10px;
        font-weight: 500;
      }
    }
  }

  .top-week-day-container {
    padding: 15px 40px 0 60px;
    border-bottom: 1px solid @calender-border-color;

    .week-container {
      width: 100%;
      display: flex;
      padding-bottom: 5px;

      .week-item {
        display: inline-block;
        flex: 1;
        height: 16px;
        line-height: 16px;
        font-size: 14px;
        font-weight: 500;
        padding-left: 10px;

        &:first-child {
          padding-left: 0;
        }
      }

      .week-time {
        width: 48px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
      }
    }
  }
  .calender-container {
    position: relative;
    display: flex;
    flex: 1;
    width: 100%;
    overflow-y: scroll;
    flex-direction: column;
    .drag-mask {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background: rgba(220, 220, 220, 0.2);
      z-index: 999;
    }
    .calender-scroll-container {
      overflow-y: scroll;
      padding-bottom: 40px;
      width: 100%;
      flex: 1;
      .calender-component {
        background: white;

        .calender-week-container {
          border-top-width: 0;
          display: flex;
          border-radius: 5px;
          margin-right: 40px;

          .calender-week-time-container {
            width: 60px;

            .week-time-item {
              height: @week-container-height;
              position: relative;
              text-align: center;

              .time-text {
                position: absolute;
                bottom: -7px;
                font-size: 14px;
                right: 15px;
              }
            }
          }

          .day-column {
            flex: 1;
            padding-right: 10px;

            &.now {
              .day-row {
                background: rgb(249, 249, 249);
              }
            }

            &:last-child {
              padding-right: 0;

              .day-row {
                padding-right: 10px;
              }
            }

            .day-row {
              height: @week-container-height;
              border-bottom: 1px dashed rgba(190, 190, 190, 1);
              display: flex;
              align-items: center;
              position: relative;
              min-width: 120px;

              &.size-2 {
                .post-item {
                  margin-left: 0;
                }
              }

              &.size-3 {
                .post-item {
                  margin-left: -30px;
                }
              }

              .post-item {
                height: @post-item-height;
                width: 48px;
                border: 1px solid #e6e6e6;
                border-top-right-radius: 8px;
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-left: -40px;
                background: white;
                cursor: pointer;
                z-index: 10;

                &:hover {
                  z-index: 100;
                }

                &:first-child {
                  margin-left: 0;
                }

                .time-text {
                  text-align: center;
                  font-size: 13px;
                  margin-top: 4px;
                  font-weight: 500;
                  line-height: 1;
                  width: 100%;
                }

                .post-image-container {
                  @image-size: 36px;
                  height: @image-size;
                  width: @image-size;
                  margin-top: 4px;

                  .post-image {
                    width: @image-size;
                    height: @image-size;
                    background-repeat: no-repeat;
                    background-size: cover;
                  }
                }

                .post-state-icon {
                  width: 20px;
                  height: 20px;
                  background-repeat: no-repeat;
                  background-size: contain;
                  position: absolute;
                  bottom: 0;
                  right: 0;
                }

                &.more {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 11px;

                  .post-image {
                    display: none;
                  }
                }
              }

              .line {
                width: 100%;
                height: 1px;
                border-bottom: 1px dashed rgba(140, 140, 140, 0.3);
                top: 50%;
                position: absolute;
              }

              &.now {
                .now-line {
                  display: block;
                }
              }

              .now-line {
                position: absolute;
                height: 2px;
                background: red;
                left: 0;
                top: -1px;
                width: 100%;
                display: none;
              }
            }
          }

          .common-post-item.story {
            .post-image-container {
              height: @post-item-height;
              width: @post-item-height;

              .post-image {
                border-radius: 50%;
                border: 2px solid white;
                width: 34px !important;
                height: 34px !important;

                .post-state-icon {
                  right: -12px;
                  bottom: -12px;
                }
              }
            }
          }
        }

        .calender-date-container {
          border-top-width: 0;

          .calender-date-item-container {
            width: 14.28%;
            display: inline-block;
            box-sizing: border-box;
            padding-right: 10px;

            &:nth-child(7n) {
              padding-right: 0;
            }

            &.now {
              .date-item {
                border-top: 2px solid @theme-color;
                background: rgb(249, 249, 249);
              }
            }

            .date-item {
              border-bottom: 1px solid @calender-border-color;
              padding: 10px;
              height: 180px;

              .day-container {
                font-size: 16px;
              }
            }
          }

          .video-icon {
            width: 25px !important;
            height: 25px !important;
          }
          .mul-icon {
            width: 13px;
            height: 13px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1300px) {
  .calender-date-container {
    .time-container {
      display: none !important;
    }
  }
}

.calender-items-component {
  margin-top: 5px;
  display: table;

  .post-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    cursor: pointer;
    @media screen and (max-width: 1850px) {
      .time-container {
        .end-time {
          display: none !important;
          background: red;
        }
      }
    }

    .time-container {
      padding-left: 10px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>
<style lang="less">
@import "../../assets/style/theme.less";

.common-post-item {
  &.story {
    .post-image-container {
      background: linear-gradient(to bottom right, #c6008b, #e1013a);

      .post-image {
        border-radius: 50%;
        border: 1px solid white;

        .post-state-icon {
          right: -2px;
          bottom: -2px;
        }
      }
    }
  }

  .post-image-container {
    display: flex;
    width: 35px;
    height: 35px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    .post-image {
      width: 33px;
      height: 33px;
      position: relative;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;
      justify-content: center;

      .mul-icon {
        background-image: url("../../../public/images/library/album@3x.png");
        width: 16px;
        height: 16px;
        background-size: contain;
        background-position: center;
        position: absolute;
        right: 1px;
        top: 1px;
      }

      .video-icon {
        width: 35px;
        height: 35px;
        z-index: 2;
        background-size: cover;
        background-image: url("../../../public/images/schedule_posts/list/video.png");
      }
      .link-icon {
        width: 23px;
        height: 23px;
        background-size: contain;
        background-position: center;
        position: absolute;
        left: -3px;
        top: -3px;
        background-image: url("../../../public/images/schedule_posts/list/icon_link@3x.png");
      }
    }

    .post-state-icon {
      width: 16px;
      height: 16px;
      background-repeat: no-repeat;
      background-size: contain;
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
  &.post-success {
    .post-state-icon {
      background-image: url("../../../public/images/schedule_posts/list/ReminderDone@3x.png");
    }
    &.story {
      .post-state-icon {
        background-image: url("../../../public/images/schedule_posts/list/Missed_story@3x.png");
      }
    }
  }
  &.del-fail {
    .time-text {
      color: @font-color-gray;
    }

    .post-image-container {
      filter: grayscale(100%);

      .post-image {
        filter: grayscale(100%);
      }
    }
  }

  &.post-fail {
    .time-text {
      color: @font-color-gray;
    }

    .post-image-container {
      filter: grayscale(100%);

      .post-image {
        filter: grayscale(100%);
      }
    }

    .post-state-icon {
      background-image: url("../../../public/images/schedule_posts/list/Reminder_Missed_story@3x.png");
    }
  }

  &.post-not-auto {
    .post-state-icon {
      display: block;
      background-image: url("../../../public/images/schedule_posts/list/Reminder_Story@3x.png");
    }
  }

  &.post-auto {
  }
  // 置灰
  &.post-lock {
    filter: grayscale(1);
    background: #ededed !important;
    &.story .post-image-container {
      background: rgba(140, 140, 140, 1) !important;
    }
    .time-text {
      color: gray;
    }
  }
}
</style>
<script>
import mediaLibraryMenu from "../../components/library_menu/Index.vue";
import calenderPreviewDialog from "../../components/media/preview_dialog/Index.vue";
import planHeader from "../../components/plan_header/Index.vue";
import { timezones } from "../../const/timezone";
import hiTabs from "../../components/common/tab/Index.vue";
import hiTabPanel from "../../components/common/tab/Panel.vue";
import moment from "moment-timezone";
import postMore from "../../components/calender/more_popover/Index";
import { list as getPostList } from "../../service/post";
import { showErrorMsg } from "../../utils/errors";
import hiTab from "../../components/common/tab/Tab";
import SchedulePostDetail from "../../components/media/schedule/detail/Detail";
import { mapGetters } from "vuex";
import { CURRENT_PUBLISHER_SIMPLE, TIMEZONE } from "../../store/mutation-types";
import GroupList from "../../components/media/schedule/GroupList";
import processLoading from "../../components/common/process/Index";
import DragPage from "../drag/Index";
import SearchRepostPage from "./Repost";
import RepostDetail from "../../components/repost/Detail";
import BulkPage from "./Bulk";
import { sleep } from "../../utils";
import {
  validateCurrentPublisherStatus,
  setCurrentPublisherCommentCaption,
} from "../../service/publisher";
import { logout } from "../../service/user";
const monthWeekStr = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
export default {
  name: "SchedulePage",
  components: {
    BulkPage,
    RepostDetail,
    SearchRepostPage,
    DragPage,
    SchedulePostDetail,
    mediaLibraryMenu,
    planHeader,
    hiTabs,
    hiTabPanel,
    calenderPreviewDialog,
    postMore,
    hiTab,
    GroupList,
    processLoading,
  },
  /**
     *post就四个状态
     成功发布是第一个灰色的
     第二个是发布失败
     第三个是手动post但是未发布
     第四个是自动post同样未发布
     */
  data() {
    return {
      monthWeekStr,
      zone: "",
      timezones,
      mediaList: [],
      repostDetailDialog: false,
      currentMonth: "",
      currentWeek: "",
      postList: [], // 接口获取post列表
      calenderType: 0, // 日历显示样式  0(周历) 1(月历)s
      listType: 0, // 列表显示类型 0(周月历) 1(列表)
      listTypeIndex: 0, // 列表中tab索引
      tabList: [{ title: "Schedule" }, { title: "Posted" }], // 列表中tab文案
      calenderLoaded: false, // 周月历数据是否已经加载
      listLoaded: false, // 列表数据是否已经加载完成
      weekPositionInit: false, // 周历位置已经初始化
    };
  },
  watch: {
    "$route.query"(val, old) {
      this.$nextTick(() => {
        // 如果是从别的页面切到schedule的则刷新
        if (
          this.pageType({ type: old.type }) !== "schedule" &&
          this.pageType({ type: val.type }) === "schedule"
        ) {
          this.initData(true);
        }
      });
    },
    /**
     * 列表周历切换
     */
    listType(val) {
      // 判断是否发生过切换
      this.weekPositionScroller();
      const currentListType = this.tabList[this.listTypeIndex].title;
      const currentCalenderType = this.calenderType === 0 ? "week" : "month";
      if (val === 1) {
        this.$router.replace({
          name: "SchedulePage",
          query: { type: currentListType },
        });
      } else {
        this.$router.replace({
          name: "SchedulePage",
          query: { type: currentCalenderType },
        });
      }
    },
    /**
     * 列表周历切换
     */
    listTypeIndex(val) {
      const currentListType = this.tabList[val].title;
      this.$router.replace({
        name: "SchedulePage",
        query: { type: currentListType },
      });
    },
    /**
     * 周月历切换
     */
    calenderType(val) {
      // 判断是否发生过切换
      this.weekPositionScroller();
      const currentCalenderType = val === 0 ? "week" : "month";
      this.$router.replace({
        name: "SchedulePage",
        query: { type: currentCalenderType },
      });
    },
    /**
     *
     */
    currentPublisher(val, old) {
      // 如果发现人员没有进行切换则不触发更新
      if (val.publisherId === old.publisherId) {
        return;
      }
      // 如果是bulk页面切换用户则直接重置一下
      if (this.$route.query.type === "bulk") {
        // 同意之后重置bulk信息
        this.$refs.bulkPage.reset();
      }
      // 判断当前Publisher状态是否有效 且不能是member
      if (
        this.currentPublisher.status === 0 &&
        !this.currentPublisher.isMember
      ) {
        if (this.currentPublisher.socialNetwork === 1) {
          // 如果选中publisher无效则让其重新登录
          this.$bus.$emit("showAddIns", {
            username: val.username,
            insType: "verify",
          });
        } else if (this.currentPublisher.socialNetwork === 2) {
          this.$bus.$emit("showAddFacebookPage", {});
        } else if (this.currentPublisher.socialNetwork === 3) {
          this.$bus.$emit("showAddFacebookGroup", {});
        } else if (this.currentPublisher.socialNetwork === 4) {
          this.$bus.$emit("showAddTwitter", {});
        }
      }
      if (
        old &&
        val.id !== old.id &&
        this.pageType({ type: this.$route.query.type }) === "schedule"
      ) {
        this.initData(true);
      }
    },
    /**
     * 时区发生改变时重新刷新数据
     */
    zone(val, old) {
      if (val) {
        this.$store.commit(TIMEZONE, val);
      }
      if (old && this.listType === 0) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapGetters({
      currentPublisher: CURRENT_PUBLISHER_SIMPLE,
      timezone: TIMEZONE,
    }),
    showOnlyText() {
      if (this.currentPublisher) {
        return this.currentPublisher.socialNetwork !== 1;
      } else {
        return false;
      }
    },
    /**
     * 计算时间范围文案
     */
    dateRangeText() {
      // 周历显示 March 18 - 24,2018
      if (this.calenderType === 0) {
        // 计算截止时间
        const endDate = moment(this.currentWeek).add(7, "days");
        // 开始时间
        const startDate = moment(this.currentWeek);
        // 如果跨年
        if (startDate.year() !== endDate.year()) {
          return `${startDate.format("MMM D, YYYY")} - ${endDate.format(
            "MMM D, YYYY"
          )}`;
        }
        // 如果跨月
        if (startDate.month() !== endDate.month()) {
          return `${startDate.format("MMM D")} - ${endDate.format(
            "MMM D, YYYY"
          )}`;
        }
        // 计算显示样式
        return `${startDate.format("MMM D")} - ${endDate.format("D, YYYY")}`;
      } else {
        // 月历 March 24,2018
        return moment(this.currentMonth).format(`MMMM, YYYY`);
      }
    },
    /**
     * 计算当前日历信息
     */
    days() {
      let days = [];
      const currentMonth = moment(this.currentMonth, "YYYY-MM-DD").set(
        "date",
        1
      );
      // 获取当前月份天数
      const currentMonthDayNum = currentMonth.daysInMonth();
      // 获取此月第一天星期
      const week = currentMonth.day();
      // 将上月部分新添加到日历中
      for (let i = week; i > 0; i--) {
        days.push({
          date: moment(currentMonth).subtract(i, "days"),
        });
      }
      // 将本月添加到日志中
      for (let i = 0; i < currentMonthDayNum; i++) {
        days.push({
          date: moment(currentMonth).add(i, "days"),
        });
      }
      // 如果最后一行有空余位置则将下月日期进行补齐
      const polishing = 7 - (days.length % 7);
      // 将下月部分新添加到日历中
      for (let i = 1; i < polishing + 1; i++) {
        days.push({
          date: moment(currentMonth).date(currentMonthDayNum).add(i, "days"),
        });
      }
      // 获取当前日期
      const currentDay = moment().tz(this.zone).format("YYYY-MM-DD");
      return days.map((d) => {
        const date = d.date.format("YYYY-MM-DD");
        // 判断是否为当天
        return {
          fullDate: date,
          date: d.date.format("D"),
          now: currentDay === date,
        };
      });
    },
    /**
     * 计算当切换到周历是，上方日期
     */
    weekDayStr() {
      // 获取当前日期
      const currentDay = moment().tz(this.zone).format("D");
      let arr = [];
      // 计算周历上面日期
      for (let i = 0; i < 7; i++) {
        const date = moment(this.currentWeek).add(i, "d");
        arr.push({
          str: `${date.format("D")} ${monthWeekStr[i]}`,
          date: date.format("YYYY-MM-DD"),
          now: date.format("D") === currentDay,
        });
      }
      return arr;
    },
    /**
     * 计算按半小时为间隔将一天拆分如(00:00 00:30 01:00 ...)
     */
    weekTimes() {
      let result = [];
      let current = moment("2011-11-11 00:00:00");
      // 计算循环次数
      const times = 24;
      for (let i = 0; i < times; i++) {
        result.push(current.add(1, "h").format("HH:mm"));
      }
      return result;
    },
  },
  methods: {
    iconClick(item) {
      console.log(item);
      this.$bus.$emit("showPostErrorMessage", { item });
    },
    /**
     * only text的点击事件
     */
    onlyTextClick() {
      const scheduleForm = {
        images: [],
        type: "new",
        form: {},
        mediaType: 1,
        fromType: "schedule",
      };
      this.$bus.$emit("showScheduleForm", scheduleForm);
    },
    async menuLogout(item) {
      if (item.index === "logout") {
        await this.switchPublisher();
        await sleep({ time: 500 });
        await this.$confirm.show({
          text: `Do you want to logout your apphi account?`,
        });
        this.$refs.bulkPage.reset();
        logout();
      }
    },
    /**
     * 切换publisher事件
     */
    async switchPublisher() {
      if (
        this.$route.query.type === "bulk" &&
        !this.$refs.bulkPage.allowLeave
      ) {
        // 如果不允许离开则弹出提示
        await this.$confirm.show({
          text: "Leave Bulk Schedule? Your schedules will be lost if you don’t upload them.",
          yesText: "Leave",
          cancelText: "Cancel",
        });
      }
      return Promise.resolve();
    },
    // 计算当前页面类型
    pageType({ type }) {
      if (type === "repost" || type === "bulk" || type === "drag") {
        return type;
      } else {
        return "schedule";
      }
    },
    /**
     * 验证是否可以被移动
     */
    onMoveCallback(evt) {
      // 左侧library 不予许移动
      if (evt.to.id === "mediaLibrary" || evt.to.id === "saveLibrary") {
        return false;
      }
      if (this.$route.query.type === "drag") {
        // 当添加项在首尾的时候可以添加 willInsertAfter指代是插入对应索引的前面还是后面(如果插入第二个位置index也是0，但是willInsertAfter = true)
        if (evt.relatedContext.index === 0 && !evt.willInsertAfter) {
          this.$bus.$emit("dragMove", evt);
          return true;
        }
        if (!evt.relatedContext.element) {
          return false;
        }
        if (evt.relatedContext.element.from === "add") {
          this.$bus.$emit("dragMove", evt);
          return true;
        } else {
          return false;
        }
      } else if (this.$route.query.type === "bulk") {
        const bulkPage = this.$refs.bulkPage;
        // 非自定义模式是可以插入任意位置
        if (bulkPage.bulkType !== 0) {
          this.$bus.$emit("dragMove", evt);
          return true;
        }
        // 计算即将插入的位置
        let addIndex = evt.relatedContext.index;
        if (evt.willInsertAfter) {
          addIndex += 1;
        }
        if (evt.willInsertAfter === undefined) {
          addIndex = evt.relatedContext.list.length;
        }
        if (addIndex === evt.relatedContext.list.length) {
          this.$bus.$emit("dragMove", evt);
          return true;
        }
        if (
          bulkPage.timeList[addIndex] &&
          bulkPage.timeList[addIndex].postTime &&
          evt.relatedContext.list.length !== addIndex
        ) {
          return false;
        }
        if (evt.relatedContext.list.length === 0) {
          this.$bus.$emit("dragMove", evt);
          return true;
        }
        // 新拆入项之后不能存在有post time
        this.$bus.$emit("dragMove", evt);
        // 临时逻辑
        return true;
      }
    },
    /**
     * 获取日历数据
     */
    async initCalender() {
      try {
        // 获取当前月历时间，并配合timezone
        let startTime = moment.tz(this.currentMonth, this.zone);
        let endTime = moment.tz(this.currentMonth, this.zone).add("month", 1);
        // 因为月历有时候会显示上月和下月部分日期，所以前后多查7天
        startTime = startTime.add("day", -7);
        endTime = endTime.add("day", 7);
        this.postList = await getPostList({
          startTime,
          endTime,
          timezone: this.zone,
        });
      } catch (e) {
        showErrorMsg(e);
      }
    },
    /**
     * 获取日历数据
     */
    async initList() {
      if (this.$refs.scheduleList && this.$refs.postedList) {
        this.$nextTick(async () => {
          try {
            await Promise.all([
              this.$refs.scheduleList.pageChange(1),
              this.$refs.postedList.pageChange(1),
            ]);
          } catch (e) {
            showErrorMsg(e);
          }
        });
      }
    },
    /**
     * 获取周历类型
     */
    weekType(date, time) {
      const length = this.postTimeInfo(date, time).length;
      if (length > 3) {
        return "size-more";
      } else {
        return `size-${length}`;
      }
    },
    /**
     * 周历计算是否为现在
     */
    weekNow(date, time) {
      const currentDateTime = moment.tz(this.timezone);
      const currentDate = currentDateTime.format("YYYY-MM-DD");
      const timeHour = moment(time, "HH:mm").subtract(1, "h").format("HH");
      if (currentDate === date && timeHour === currentDateTime.format("HH")) {
        return "now";
      }
    },
    /**
     * 展示post的详细信息
     */
    async showPostDetail(item) {
      // 验证当前用户是否需要登录，如果需要登录则弹出提示
      if (!validateCurrentPublisherStatus()) {
        return;
      }
      if (item.state === "post-lock") {
        await this.$msgbox({
          title: "",
          showCancelButton: true,
          message:
            "No more unlimited schedules accounts available. Please upgrade your plan to get more.",
          distinguishCancelAndClose: true,
          confirmButtonText: this.$t("common.upgrade"),
          cancelButtonText: this.$t("common.cancel"),
        });
        this.$router.push({ name: "UpgradePage" });
        return;
      }
      // 判断当前post状态 如果是is_activate === false 弹出升级提示
      this.$refs.postDetail.show(item);
    },
    /**
     * 计算某天post信息
     */
    postDayInfo(dayIndex) {
      const date = this.days[dayIndex].fullDate;
      const postInfo = this.postList.find((p) => p.postTime === date);
      return {
        date: date,
        items: postInfo ? postInfo.items : [],
      };
    },
    /**
     * 计算某天某个时间点post信息
     */
    postTimeInfo(date, time) {
      const postInfo = this.postList.find((p) => p.postTime === date);
      let datetime = moment(`${date} ${time}`);
      if (time === "00:00") {
        datetime = datetime.add(1, "d");
      }
      if (postInfo) {
        // 获取当前时间段符合条件数据
        const startTime = moment(datetime).subtract(1, "h");
        const endTime = moment(datetime);
        const items = [];
        postInfo.items.forEach((val) => {
          const itemPostTime = moment(`${date} ${val.postTimeStr}`);
          if (
            itemPostTime.isBetween(startTime, endTime) ||
            itemPostTime.isSame(startTime)
          ) {
            items.push(val);
          }
        });
        return items;
      }
      return [];
    },
    /**
     * 图片选中时间
     */
    select(m) {
      this.$refs.previewDialog.open(m);
    },
    /**
     * save select 点击回调
     */
    savedSelected(postInfo) {
      this.$bus.$emit("showRepostDetail", postInfo);
    },
    /**
     * 当天按钮点击事件
     */
    async today() {
      const today = moment().tz(this.zone);
      // 判断如果当期选择的是周历，则在当前周基础上进行增减，否则增加在月上
      // 计算当前周
      this.currentWeek = moment()
        .tz(this.zone)
        .subtract(moment().tz(this.zone).format("d"), "d")
        .format("YYYY-MM-DD");
      // 计算当前月份
      this.currentMonth = today.set("date", 1).format("YYYY-MM-DD");
      await this.initData();
    },
    /**
     * 修改当前月份
     * @param num 增減數量
     */
    async updateMonth(num) {
      // 判断如果当期选择的是周历，则在当前周基础上进行增减，否则增加在月上
      let currentWeek = moment.tz(this.currentWeek, this.zone);
      let currentMonth = moment.tz(this.currentMonth, this.zone);
      if (this.calenderType === 0) {
        currentWeek.add(num * 7, "days");
        // 判斷当前周是否和当前月不符
        if (currentWeek.format("YYYY-MM") !== currentMonth.format("YYYY-MM")) {
          currentMonth = currentWeek.clone().set("date", 1);
        }
      } else {
        currentMonth.add(num, "months");
        // 判斷当前周是否和当前月不符
        if (currentWeek.format("YYYY-MM") !== currentMonth.format("YYYY-MM")) {
          currentWeek = currentMonth.clone().weekday(0);
        }
      }
      this.currentWeek = currentWeek.format("YYYY-MM-DD");
      this.currentMonth = currentMonth.format("YYYY-MM-DD");
      await this.initData();
    },
    /**
     * 初始化数据
     */
    async initData(all) {
      if (this.$refs.calenderProcess) {
        this.$refs.calenderProcess.start();
      }
      // 如果all 则全查
      if (all) {
        await Promise.all([
          this.initCalender(),
          this.initList(),
          setCurrentPublisherCommentCaption({
            publisherId: this.currentPublisher.publisherId,
          }),
        ]);
      } else {
        if (this.listType === 0) {
          await this.initCalender();
        } else if (this.listType === 1) {
          await this.initList();
        }
      }
      if (this.$refs.calenderProcess) {
        this.$refs.calenderProcess.done();
      }
    },
    /**
     * 周历滚动初始化
     */
    weekPositionScroller() {
      // 如果位置更新过 则不再更新
      if (this.weekPositionInit) {
        return;
      }
      this.$nextTick(() => {
        const today = moment();
        const weekScroll = document.getElementById("weekScroll");
        if (weekScroll.clientHeight && weekScroll.clientHeight > 0) {
          weekScroll.scrollTop = 90 * today.hours() - 30;
          this.weekPositionInit = true;
        }
        if (this.currentPublisher) {
          this.initData(true);
        }
      });
    },
  },
  async created() {
    // 初始化当前时区
    this.zone = this.timezone;
    const today = moment();
    // 计算当前月份
    this.currentMonth = today.set("date", 1).tz(this.zone).format("YYYY-MM-DD");
    // 计算当前周
    this.currentWeek = moment()
      .tz(this.zone)
      .subtract(moment().tz(this.zone).format("d"), "d")
      .format("YYYY-MM-DD");
    /**
     * 此处为防刷新机制，每次刷新仍保持固定页
     */
    if (this.$route.query.type === "Schedule") {
      this.listType = 1;
      this.listTypeIndex = 0;
    }
    if (this.$route.query.type === "Posted") {
      this.listType = 1;
      this.listTypeIndex = 1;
    }
    if (this.$route.query.type === "week") {
      this.listType = 0;
      this.calenderType = 0;
    }
    if (this.$route.query.type === "month") {
      this.listType = 0;
      this.calenderType = 1;
    }
    this.weekPositionInit = false;
    this.weekPositionScroller();
    this.$bus.$off("toInsProfile");
    this.$bus.$on("toInsProfile", (data) => {
      this.$router.push({ name: "SchedulePage", query: { type: "repost" } });
      this.$refs.repostPage.toInsProfile(data);
    });
    this.$bus.$off("scheduleSuccess");
    // form表单更新则自动刷新一下
    this.$bus.$on("scheduleSuccess", () => {
      this.initData(true);
    });
    this.$bus.$off("switchMenu");
    this.$bus.$on("switchMenu", (item) => {
      this.menuLogout(item);
    });
  },
  beforeRouteLeave(to, from, next) {
    // 判断bulk是否允许离开
    this.switchPublisher()
      .then(() => {
        this.$refs.bulkPage.reset();
        next();
      })
      .catch(() => {
        next(false);
      });
  },
};
</script>
